<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <Modal
            :text="modalText"
            id="modal_show"
        />

        <b-modal id="pay-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('payWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="payDebts">{{
                        $t('yes')
                    }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$bvModal.hide('pay-modal')">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>

        <b-modal size="xl" id="my-modal-data" :title="$t('product.title')" ok-only>
            <table class="table overflow-auto table-striped mt-3">
                <thead>
                <tr>
                    <th scope="col" class="d-none d-lg-table-cell">{{ $t('id') }}</th>
                    <th scope="col">{{ $t('product.title') }}</th>
                    <th scope="col" class="d-none d-md-table-cell">{{ $t('amount') }}</th>
                    <th scope="col" class="d-none d-lg-table-cell">{{ $t('price') }}</th>
                    <th scope="col">{{ $t('printView.totalSum') }}</th>
                    <th scope="col" class="d-none d-md-table-cell">{{ $t('payed') }}</th>
                    <th scope="col">{{ $t('debt') }}</th>
                    <th scope="col" class="d-none d-lg-table-cell">{{ $t('date') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in getSupplierFee.products"
                    :key="item.id"
                >
                    <td class="d-none d-lg-table-cell">{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td class="d-none d-md-table-cell">{{ item.amount }}</td>
                    <td class="d-none d-lg-table-cell">
                        {{ showCurrencyById(item.currency, item.pricePerUnit) }}
                    </td>
                    <td>{{ showCurrencyById(item.currency, item.totalPrice) }}</td>
                    <td class="d-none d-md-table-cell">
                        {{ showCurrencyById(item.currency, item.payedAmount) }}
                    </td>
                    <td>{{
                            showCurrencyById(item.currency, item.totalPrice - item.payedAmount)
                        }}
                    </td>
                    <td class="d-none d-lg-table-cell">
                        {{ dateTimeFormat(item.createdAt, false) }}
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="table-bordered text-uppercase font-weight-bold d-flex justify-content-around">
                <div>
                    <h5>{{ $t('printView.totalSum') }}</h5>
                </div>
                <div>
                    <h5>{{ showCurrencyById(baseCurrencyId, getSupplierFee.totalSum) }}</h5>
                </div>
            </div>

            <div class="table-bordered font-weight-bold d-flex justify-content-around">
                <div>
                    <h5>{{ $t('payed') }}</h5>
                </div>
                <div>
                    <h5>{{ showCurrencyById(baseCurrencyId, getSupplierFee.totalPayment) }}</h5>
                </div>
            </div>

            <div class="table-bordered font-weight-bold d-flex justify-content-around">
                <div>
                    <h5>{{ $t('debt') }}</h5>
                </div>
                <div>
                    <h5>{{ showCurrencyById(baseCurrencyId, totalDebt) }}</h5>
                </div>
            </div>

        </b-modal>

        <!--        checkbox        -->
        <div class="py-4">
            <div class="col-12 col-md-4 mt-2 btn-group btn-group-toggle" data-toggle="buttons">
                <label class="btn btn-primary button-stat active font-bold flex justify-center items-center"
                       style="height: 44px !important;">
                    <input id="person" type="radio" @click="goPerson" name="options" checked>{{ $t('person.title') }}
                </label>
                <label class="btn btn-primary button-stat font-bold flex justify-center items-center"
                       style="height: 44px !important;">
                    <input id="company" type="radio" @click="goCompany" name="options">{{ $t('company.title') }}
                </label>
            </div>
        </div>

        <!--        company form        -->
        <template v-if="modelForm.isCompany">
            <div class="grid grid-cols-12 gap-3  mt-4 container">
                <div class="col-span-12 md:col-span-5 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('company.name') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="companyName"
                        :model-form="modelForm"
                        :errors="errors"
                        check-to-model="modelNotEmptyState"
                        :column-no-top-margin="true"
                        :model-state="modelNotEmptyState"
                    />
                </div>
                <div class="col-span-12 md:col-span-5 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('company.telephone') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="companyTelephone"
                        check-to-model="modelPhoneOrEmpty"
                        :model-form="modelForm"
                        :errors="errors"
                        :model-state="modelPhoneOrEmpty"
                    />
                </div>
            </div>
            <div v-if="this.$route.name !=='suppliers/add' && canSeeCustomerDebts()"
                 class="grid grid-cols-12 container mt-4">
                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2 h-7">
                        <span @click="sumDebt > 0 ? $bvModal.show('my-modal-data'): ''"
                              class="cursor-pointer font-bold">{{ $t('debt') }} {{
                                numberWithCommas(this.sumDebt)
                            }}</span>

                        <b-form-select v-if="sumDebt > 0" class="border-0 w-20 focus:ring-0"
                                       v-model="currentCurrencyShortName">
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                    <b-form-input
                        class="border-gray-300 focus:ring-0 h-11"
                        v-model="payDebt"
                        type="number"
                        min="0"
                        @input="changeInput"
                    />

                    <span v-if="isMore" class="text-red-500 font-bold absolute">{{ $t('errorData') }}</span>
                </div>

                <div class="col-span-2 mt-7 pr-3">
                    <button
                        type="button"
                        class="h-11 bg-main rounded-r border-0 w-full font-bold focus:ring-0 focus:outline-none text-white hover:bg-hoverMain"
                        :disabled="isMore"
                        @click.prevent="$bvModal.show('pay-modal'); payDebt = sumDebt">
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                              aria-hidden="true"></span>
                        {{ $t('filter.all') }}
                    </button>
                </div>

                <div class="col-span-2 mt-7">
                    <button
                        type="button"
                        class="h-11 bg-main rounded border-0 w-32 font-bold focus:ring-0 focus:outline-none text-white hover:bg-hoverMain"
                        :disabled="isMore || payDebt === null || payDebt === '' || payDebt === '0'"
                        @click.prevent="$bvModal.show('pay-modal')"
                    >
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                              aria-hidden="true"></span>
                        {{ $t('pay') }}
                    </button>
                </div>
            </div>
        </template>

        <!--        person form         -->
        <template v-if="!modelForm.isCompany">
            <div class="grid grid-cols-12 gap-3 mt-4 container">
                <div class="col-span-12 md:col-span-6 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.givenName') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="givenName"
                        :model-form="modelForm"
                        :errors="errors"
                        check-to-model="modelNotEmptyState"
                        :column-no-top-margin="true"
                    />
                </div>

                <div class="col-span-12 md:col-span-6 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.familyName') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="familyName"
                        check-to-model="modelNotEmptyState"
                        :errors="errors"
                        :model-form="modelForm"
                        :column-is-fill="false"
                    />
                </div>

                <div class="col-span-12 md:col-span-6 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.telephone') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="telephone"
                        check-to-model="modelPhoneOrEmpty"
                        :model-form="modelForm"
                        :errors="errors"
                    />
                </div>

                <div class="col-span-12 md:col-span-6 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.gender.title') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <b-form-select v-model="modelForm.gender" class="h-11 border-gray-300 focus:ring-0">
                        <b-form-select-option :value="1">{{ $t('person.gender.man') }}</b-form-select-option>
                        <b-form-select-option :value="0">{{ $t('person.gender.woman') }}</b-form-select-option>
                    </b-form-select>
                </div>
            </div>
            <div v-if="this.$route.name !=='suppliers/add' && canSeeCustomerDebts()"
                 class="grid grid-cols-12 container mt-4">
                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2 h-7">
                        <span @click="sumDebt > 0 ? $bvModal.show('my-modal-data'): ''"
                              class="cursor-pointer font-bold">{{ $t('debt') }} {{
                                numberWithCommas(this.sumDebt)
                            }}</span>

                        <b-form-select v-if="sumDebt > 0" class="border-0 w-20 focus:ring-0"
                                       v-model="currentCurrencyShortName">
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                    <b-form-input
                        class="border-gray-300 focus:ring-0 h-11"
                        v-model="payDebt"
                        type="number"
                        min="0"
                        @input="changeInput"
                    />

                    <span v-if="isMore" class="text-red-500 font-bold absolute">{{ $t('errorData') }}</span>
                </div>

                <div class="col-span-2 mt-7 pr-3">
                    <button
                        type="button"
                        class="h-11 bg-main rounded-r border-0 w-full font-bold focus:ring-0 focus:outline-none text-white hover:bg-hoverMain"
                        :disabled="isMore"
                        @click.prevent="$bvModal.show('pay-modal'); payDebt = sumDebt">
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                              aria-hidden="true"></span>
                        {{ $t('filter.all') }}
                    </button>
                </div>

                <div class="col-span-2 mt-7">
                    <button
                        type="button"
                        class="h-11 bg-main rounded border-0 w-32 font-bold focus:ring-0 focus:outline-none text-white hover:bg-hoverMain"
                        :disabled="isMore || payDebt === null || payDebt === '' || payDebt === '0'"
                        @click.prevent="$bvModal.show('pay-modal')"
                    >
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                              aria-hidden="true"></span>
                        {{ $t('pay') }}
                    </button>
                </div>
            </div>
        </template>

        <!--        add debt        -->
        <div class="container py-2">
            <SearchCollapse text-button="addDebt" :is-bg-white="true" class="">
                <div class="grid grid-cols-12 gap-3">
                    <div class="col-span-12 md:col-span-6 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('addDebt') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="debt"
                            :model-form="modelForm"
                            :errors="errors"
                        />
                    </div>

                    <div class="col-span-12 md:col-span-6 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('currency') }}
                        </div>
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="modelForm.currencyId">
                            <b-form-select-option :value=0>UZS</b-form-select-option>
                            <b-form-select-option :value=1>USD</b-form-select-option>
                            <b-form-select-option :value=2>RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                </div>
            </SearchCollapse>
        </div>

        <!--        button company      -->
        <div class="container py-4" v-if="modelForm.isCompany">
            <SubmitRow
                v-if="canManagerSuppliers()"
                :text="submitButtonName"
                :is-disabled="hasErrorsIn(errorsCompany)"
                :is-loading="isLoading"
                :do-action="addOrEdit"
            />
        </div>

        <!--        button person      -->
        <div class="container py-4" v-if="!modelForm.isCompany">
            <SubmitRow
                v-if="canManagerSuppliers()"
                :text="submitButtonName"
                :is-disabled="hasErrorsIn(errorsPerson)"
                :is-loading="isLoading"
                :do-action="addOrEdit"
            />
        </div>

        <button
            @click="hasSalesSupplier = !hasSalesSupplier"
            class="mt-3"
            style="border: none; outline: none; background-color: #FFFFFF; color: #6f42c1; font-size: 20px"
            v-if="this.$route.name !== 'suppliers/add' && getProductPurchasesTotalCount > 0"
        >
            <ins> {{ $t('sale.purchaseHistory') }}</ins>
            <span v-if="hasSalesSupplier">&#9650;</span>
            <span v-else>&#9660;</span>
        </button>

        <span v-show="hasSalesSupplier">
            <RowColumn>

                <SearchCollapse class="mb-3 mb-sm-0">
                    <div class="text-center mb-2 justify-content-around">
                        <b-form-group>
                            <b-form-radio-group
                                v-model="search.isPayed"
                                :options="options"
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div class="justify-content-around p-0 col-md-8 col-lg-7 d-md-flex">
                        <b-form-input
                            v-model="search.sumMin"
                            :placeholder="$t('filter.fromSum')"
                            class="mr-md-1"
                            type="number"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                        <b-form-input
                            v-model="search.sumMax"
                            :placeholder="$t('filter.toSum')"
                            class="mr-md-1"
                            type="number"
                            @keyup.enter="searchSalesInfo"
                        >
                        </b-form-input>
                    </div>

                    <div class="d-flex mb-1 justify-content-between mt-3">
                        <div class="d-flex flex-wrap justify-content-start col-11 pl-0">
                            <b-button
                                style="outline: none; border: none; background-color: #ffffff; padding: 0"
                                v-b-modal.my-modal>
                                <IconButton
                                    icon="calendar-alt"
                                    title="filter.thisDay"
                                />
                            </b-button>
                            <b-modal id="my-modal" :title="$t('filter.thisDay')">
                                <b-input-group>
                                    <b-form-input
                                        v-model="search.after"
                                        type="text"
                                        :placeholder="$t('filter.fromDateToDate')"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker
                                            v-model="search.after"
                                            button-only
                                            locale="en-US"
                                        ></b-form-datepicker>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-modal>
                            <span class="date text-primary mr-sm-3">{{ this.search.after }}</span>
                            <b-button
                                v-b-modal.modal-1
                                style="outline: none; border: none; background-color: #ffffff ; padding: 0">
                                <IconButton
                                    icon="calendar-alt"
                                    title="filter.toDay"
                                    :has-margin-right="false"
                                />
                            </b-button>
                            <b-modal id="modal-1" :title="$t('filter.toDay')">
                                <b-input-group>
                                    <b-form-input
                                        v-model="search.before"
                                        type="text"
                                        :placeholder="$t('filter.fromDateToDate')"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker
                                            v-model="search.before"
                                            button-only
                                            locale="en-US"
                                        ></b-form-datepicker>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-modal>
                            <span class="date text-primary ml-1">{{ this.search.before }}</span>
                        </div>
                        <div class="d-flex justify-content-end col-1">
                            <IconButton
                                title="search"
                                :do-action="searchSalesInfo"
                                icon="search"
                            />
                            <IconButton
                                title="filter.clear"
                                :do-action="resetSaleSearchInfo"
                                icon="eraser"
                                :has-margin-right="false"
                            />
                        </div>

                    </div>
                </SearchCollapse>
                <h5 class="float-right">
                    {{ $t('totalSalesAmount') }}:
                    <span
                        class="text-primary">{{
                            showCurrencyById(getSupplierPurchasesTotalAmount[1], getSupplierPurchasesTotalAmount[0])
                        }}</span>
                </h5>

            </RowColumn>
            <div>
                <table class="table">
                    <thead>
                        <tr>
                            <th class="d-none d-md-table-cell"> #</th>
                            <th>{{ $t('date') }}</th>
                            <th>{{ $t('product.name') }}</th>
                            <th class="d-none d-lg-table-cell">{{ $t('product.productAmount') }}</th>
                            <th class="d-none d-lg-table-cell">{{ $t('price') }}</th>
                            <th class="d-none d-sm-table-cell">{{ $t('totalPrice') }}</th>
                            <th class="d-none d-xl-table-cell">{{ $t('payed') }}</th>
                            <th>{{ $t('actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(purchase, index ) of getProductPurchases" :key="index"
                            :style="{backgroundColor: backgroundColor(purchase.totalPrice, purchase.payedAmount)}">
                            <td class="d-none d-md-table-cell">{{ purchase.id }}</td>
                            <td>{{ dateTimeFormat(purchase.createdAt, true) }}</td>
                            <td>{{ purchase.product.name }}</td>
                            <td class="d-none d-lg-table-cell">
                                {{ purchase.amount }} {{ showUnitOfMeasure(purchase.product.unitOfMeasure) }}
                            </td>
                            <td class="d-none d-lg-table-cell">
                                {{ showCurrencyById(purchase.currency.id, purchase.pricePerUnit) }}
                            </td>
                            <td class="d-none d-sm-table-cell">{{
                                    showCurrencyById(purchase.currency.id, purchase.totalPrice)
                                }}</td>
                            <td v-if="purchase.payedAmount > 0" class="d-none d-xl-table-cell">
                                {{ showCurrencyById(purchase.currency.id, purchase.payedAmount) }}
                            </td>
                            <td v-else class="d-none d-xl-table-cell"> - </td>
                            <td class="text-md-center">
                                <IconButton title="view" icon="eye" :url="'products/transactions/' + purchase.id"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <RowColumn>
                <Pagination
                    :search="search"
                    :base-url="'suppliersId/' + this.search.supplierId"
                    :total-items="getProductPurchasesTotalCount"
                    method-name="fetchProductPurchaseSupplier"/>
            </RowColumn>
        </span>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import Row from "../../components/html/Row";
import RowColumn from "../../components/RowColumn";
import InputBox from "../../components/InputBox";
import SubmitRow from "../../components/SubmitRow";
import Modal from "@/components/html/Modal";
import accessMixin from "../../mixin/accessMixin";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormattingMixin from "../../mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import SearchCollapse from "../../components/SearchCollapse";
import Pagination from "@/components/html/Pagination";
import IconButton from "@/components/IconButton";


export default {
    name: "SupplierAdd",
    mixins: [validatorMixin, accessMixin, dateFormattingMixin, currencyFormatMixin, currencyRateMixin],
    computed: {
        ...mapGetters([
            'getSupplier',
            'getSupplierFee',
            'getUserCompanyId',
            'getProductPurchases',
            'getProductPurchasesTotalCount',
            'getSupplierPurchasesTotalAmount'
        ]),
        errorsCompany() {
            return {
                companyName: this.errors.companyName,
                companyTelephone: this.errors.companyTelephone
            }
        },
        errorsPerson() {
            return {
                givenName: this.errors.givenName,
                familyName: this.errors.familyName,
                telephone: this.errors.telephone
            }
        }
    },
    data() {
        return {
            hasSalesSupplier: false,
            color: '#FFEEBA',
            submitButtonName: 'add',
            modalText: '',
            isLoading: false,
            search: {
                supplierId: this.$route.params.id,
                isPayed: null,
                after: '',
                before: '',
                totalPriceMin: '',
                totalPriceMax: '',
                page: this.$route.params.page
            },
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('payed'), value: true},
                {text: this.$t('onCredit'), value: false}
            ],
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'supplier.title', url: 'suppliers'},
                this.$route.name === 'suppliers/add' ? {name: 'add'} : {name: 'edit'},
            ],
            errors: {
                companyName: null,
                companyTelephone: null,
                givenName: null,
                familyName: null,
                gender: null,
                telephone: null,
            },
            modelForm: {
                id: null,
                isCompany: false,
                companyName: '',
                companyTelephone: '',
                givenName: '',
                familyName: '',
                gender: 1,
                telephone: '',
                debt: '',
                currencyId: 0,
            },
            sumDebt: 0,
            payDebt: null,
            totalDebt: 0,
            isMore: false
        }
    },
    watch: {
        'currentCurrencyShortName'(newVal, oldVal) {
            this.sumDebt = this.calculateAmountByBaseCurrency(this.sumDebt, oldVal, newVal)
        },
    },
    methods: {
        ...mapActions([
            'putSupplier',
            'pushSupplier',
            'fetchSupplier',
            'fetchSupplierFee',
            'payToSupplier',
            'fetchProductPurchaseSupplier',
            'fetchSupplierPurchasesTotalAmount',
            'setBreadcrumbItems'
        ]),
        goCompany() {
            this.modelForm.isCompany = true
        },
        goPerson() {
            this.modelForm.isCompany = false
        },
        resetSaleSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchSalesInfo()
        },
        backgroundColor(totalPrice, payedAmount) {
            if (totalPrice > payedAmount) {
                return this.color
            }
        },
        searchSalesInfo() {
            this.$root.showOverlay = true
            this.search.page = 1

            this.fetchProductPurchaseSupplier(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        changeInput() {
            this.isMore = parseInt(this.payDebt) > parseInt(this.sumDebt);
        },
        payDebts() {
            this.$bvModal.hide('pay-modal')
            this.$root.showOverlay = true

            this.payToSupplier({
                id: this.$route.params.id,
                paymentAmount: parseFloat(this.payDebt),
                currency: this.getCurrencyByShortName(this.currentCurrencyShortName)['@id']
            })
                .then(() => {
                    this.$router.go(0)
                })
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        addOrEdit() {
            if (this.$route.name === 'suppliers/add') {
                this.isLoading = true

                if (this.modelForm.isCompany) {
                    this.pushSupplier({
                        isCompany: this.modelForm.isCompany,
                        companyName: this.modelForm.companyName,
                        companyTelephone: this.modelForm.companyTelephone,
                        debt: this.modelForm.debt,
                        currency: '/api/currencies/' + this.modelForm.currencyId,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('suppliers')
                        })
                        .catch((reason) => {
                            if (reason === 'You have not available credits') {
                                this.modalText = this.$t('error.overLimit')
                            } else {
                                this.modalText = reason
                            }

                            this.$bvModal.show('modal_show')
                        })
                } else {
                    this.pushSupplier({
                        isCompany: this.modelForm.isCompany,
                        personGivenName: this.modelForm.givenName,
                        personFamilyName: this.modelForm.familyName,
                        personGender: this.modelForm.gender,
                        personTelephone: this.modelForm.telephone,
                        debt: this.modelForm.debt,
                        currency: '/api/currencies/' + this.modelForm.currencyId,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('suppliers')
                        })
                        .catch((reason) => {
                            if (reason === 'You have not available credits') {
                                this.modalText = this.$t('error.overLimit')
                            } else {
                                this.modalText = reason
                            }

                            this.$bvModal.show('modal_show')
                        })
                }
                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            } else {
                this.isLoading = true

                if (this.modelForm.isCompany) {
                    this.putSupplier({
                        url: 'supplier_companies',
                        id: this.modelForm.id,
                        name: this.modelForm.companyName,
                        telephone: this.modelForm.companyTelephone,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('suppliers')
                        })
                        .catch((reason) => {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                } else {
                    this.putSupplier({
                        url: 'people',
                        id: this.modelForm.id,
                        givenName: this.modelForm.givenName,
                        familyName: this.modelForm.familyName,
                        gender: this.modelForm.gender,
                        telephone: this.modelForm.telephone
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('suppliers')
                        })
                        .catch((reason) => {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        })
                }

                this.putSupplier({
                    url: 'suppliers',
                    id: this.$route.params.id,
                    debt: (Number(this.modelForm.debt) + Number(this.getSupplier.debt)).toString(),
                    currency: '/api/currencies/' + this.modelForm.currencyId,
                })
                    .then(() => {
                        this.$i18nHelper.toUrl('suppliers')
                    })
                    .catch((reason) => {
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })

                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            }
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        if (this.$route.name === 'suppliers/edit' || this.$route.name === 'suppliersId') {
            this.$root.showOverlay = true
            this.submitButtonName = 'edit'

            this.fetchSupplierPurchasesTotalAmount(this.$route.params.id)
            this.fetchSupplier(this.$route.params.id)
                .then(() => {
                    if (this.canManagerSuppliers()) {
                        this.fetchSupplierFee(this.$route.params.id)
                            .then(() => {
                                this.sumDebt = this.getSupplierFee.ourDebt.toFixed(2)
                                this.totalDebt = this.getSupplierFee.ourDebt.toFixed(2)
                            })
                    }

                    if (!this.getSupplier.isCompany) {
                        document.getElementById('person').click()
                        this.modelForm.isCompany = false
                        this.modelForm.id = this.getSupplier.person.id
                        this.modelForm.givenName = this.getSupplier.person.givenName
                        this.modelForm.familyName = this.getSupplier.person.familyName
                        this.modelForm.telephone = this.getSupplier.person.telephone ? this.getSupplier.person.telephone : ''
                        this.modelForm.gender = this.getSupplier.person.gender
                    } else {
                        document.getElementById('company').click()
                        this.modelForm.id = this.getSupplier.supplierCompany.id
                        this.modelForm.companyName = this.getSupplier.supplierCompany.name
                        this.modelForm.companyTelephone = this.getSupplier.supplierCompany.telephone ? this.getSupplier.supplierCompany.telephone : ''
                    }

                    this.$root.showOverlay = false
                })
        }
    },
    components: {
        IconButton,
        Pagination,
        SubmitRow,
        InputBox,
        RowColumn,
        Row,
        Modal,
        SearchCollapse
    }
}
</script>
<style scoped>
.active {
    border: 3px solid #8300C5;
}

.button-stat {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background-color: #E5E5E5;
    color: #707070;
    font-size: 16px;
    height: 30px;
}

.button-stat:checked:active:focus {
    background-color: #6539B2 !important;
}

.button-stat:active {
    background-color: #6539B2 !important;
}
</style>